class BogoSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.inputs = Array.from(this.querySelectorAll('input[data-bogo-quantity]'));
    this.stickyATC = document.querySelector('.product__sticky-atc');
    this.stickyATCInfo = document.querySelector('.product__sticky-atc-info');

    this.inputs.forEach(input => {
      input.addEventListener('change', (e) => this.onInputChange(e.target));
    });
  }

  onInputChange(checkedInput) {
    if (!checkedInput?.checked) return;

    this.updateQuantity(checkedInput);
    this.updateMainPrice(checkedInput);
  }

  updateQuantity(input) {
    const quantity = input.dataset.bogoQuantity;
    const currentQuantityElement = this.querySelector('[data-bogo-current-quantity]');
    if (currentQuantityElement) {
      currentQuantityElement.textContent = quantity;
    }
  }

  updateMainPrice(input) {
    const newPriceHTML = input.nextElementSibling?.querySelector('price-snippet .price')?.innerHTML;
    const productInfoPrice = document.querySelector('.product__info-wrapper')?.querySelector('[data-current-price] .price__container div');
    
    if (newPriceHTML && productInfoPrice) {
      productInfoPrice.innerHTML = newPriceHTML;
    }

    const buttonPrice = this.closest('.product__info-wrapper')?.querySelector('[id*="ProductSubmitButton-"] [data-button-price]');
    if (newPriceHTML && buttonPrice) {
      buttonPrice.innerHTML = newPriceHTML;
    }
  }
}

customElements.define('bogo-selector', BogoSelector);